/* RESPONSIBLE TEAM: team-ai-agent */

import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type AiAgentGuidelineService from 'embercom/services/ai-agent-guideline-service';

export default class AutomationFinAIAgentEscalationController extends Controller {
  @service declare aiAgentGuidelineService: AiAgentGuidelineService;

  queryParams = ['openGuideline'];

  @tracked private _openGuideline: string | null = null;

  get openGuideline(): string | null {
    return this._openGuideline;
  }

  set openGuideline(value: string | null) {
    this._openGuideline = value;

    if (value) {
      this.aiAgentGuidelineService.setOpenGuidelineId(value);
      this._openGuideline = null;
    }
  }
}
